import { ThemeIcon } from "@mantine/core"
import { IconCircleCheck } from "@tabler/icons-react"

type SuccessCheckIconProps = {
  size?: number
  iconSize?: number
}

/**
 * Circled success check for confirmation states (e.g. auth success screens).
 */
export const SuccessCheckIcon = ({
  size = 48,
  iconSize,
}: SuccessCheckIconProps) => {
  const resolvedIconSize = iconSize ?? Math.round(size * 0.58)

  return (
    <ThemeIcon
      size={size}
      radius="xl"
      variant="light"
      aria-hidden
      style={{
        backgroundColor: "var(--mantine-color-green-0)",
        color: "var(--mantine-color-success)",
      }}
    >
      <IconCircleCheck size={resolvedIconSize} stroke={1.75} />
    </ThemeIcon>
  )
}
